import React from "react";
import { VegaLogo } from "assets";
import { LanguageSwitcher } from "./LanguageSwitcher";

export const ScanHeader = ({ item, currentLanguage, onLanguageChange }) => {
  return (
    <header className="scan__header">
      <VegaLogo className="scan__logo" />
      <h2 className="scan__title">{item.itemId}</h2>
      <LanguageSwitcher currentLanguage={currentLanguage} onLanguageChange={onLanguageChange} />
    </header>
  );
};
